import { FileUpload, FileUploadHandlerEvent } from "primereact/fileupload";
import { connect } from "react-redux";
import { useRef } from "react";

interface FileUploaderProps {
  headerText: string,
  multipleUpload: boolean,
  uploadResume: (resumeData: FormData) => any
}

const FileUploader = (props: FileUploaderProps) => {
  const { headerText, multipleUpload, uploadResume } = props
  const fileRef = useRef<FileUpload>(null);

  // single upload
  const beginUpload = async (file: File) => {
    let formData = new FormData();
    formData.append("file", file);
    await uploadResume(formData)
  }

  // multiple upload
  const beginUploadMultiple = async (files: File[]) => {
    let formData = new FormData();
    files.forEach((file) => {
      formData.append(`files`, file);
    });
    await uploadResume(formData)
  }

  // const fileToBlob = async (file: File) => new Blob([new Uint8Array(await file.arrayBuffer())], { type: file.type })

  const fileUploadHandler = async (upload: FileUploadHandlerEvent) => {
    if (multipleUpload) {
      await beginUploadMultiple(upload.files)
    } else {
      // use the first file
      await beginUpload(upload.files[0])
    }

    // reset
    if (fileRef.current !== null)
      fileRef.current.clear()
  }

  const emptyTemplate = () => {
    return (
      <div className="flex align-items-center flex-column">
        <i className="pi pi-upload mt-3 p-5" style={{ 'fontSize': '3em', borderRadius: '50%', backgroundColor: 'var(--surface-b)', color: 'var(--surface-d)' }}></i>
        <span style={{ 'fontSize': '1.2em', color: 'var(--text-color-secondary)' }} className="my-5">Drag and Drop Resume Here</span>
      </div>
    )
  }

  return (
    <div>
      <h4>{headerText}</h4>
      <p style={{ fontSize: "0.8em" }}>Accepted file formats: <em>(.jpeg, .png, .pdf, .tiff)</em></p>
      <p style={{ fontSize: "0.8em" }}>Max file size: <em>10MB</em></p>
      <FileUpload
        ref={fileRef}
        style={{ width: '25vw' }}
        accept=".JPEG, .PNG, .PDF, .TIFF"
        customUpload={true}
        uploadHandler={fileUploadHandler}
        auto={true}
        multiple={multipleUpload}
        maxFileSize={10000000}
        emptyTemplate={emptyTemplate}
      />
    </div>
  )
}

export default FileUploader